/* Kuwait consultation milestones. No answers, contact data or product diagnoses. */
(function () {
  'use strict';
  if (window.TaraMetaSignals) return;
  const names = new Set(['ConsultationStarted', 'ConsultationEngaged', 'ConsultationCompleted', 'ConsultationResultsViewed', 'ConsultationRoutineAdded']);
  const prefix = 'tara:meta:';
  const pending = new Map();
  const sent = new Set();
  let timer = null;
  function loadPrivacy(attempt) {
    if (window.Shopify?.customerPrivacy) return;
    if (typeof window.Shopify?.loadFeatures === 'function') {
      try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {}); } catch (_) {}
    } else if (attempt < 5) setTimeout(function () { loadPrivacy(attempt + 1); }, 500);
  }
  // Load the permission reader, never set consent on a customer's behalf.
  loadPrivacy(0);
  function allowed() {
    try {
      const p = window.Shopify?.customerPrivacy;
      return !window.Shopify?.designMode && location.hostname === 'taraformula.com.kw'
        && !new URLSearchParams(location.search).has('preview_theme_id')
        && p?.marketingAllowed() === true && p?.analyticsProcessingAllowed() === true
        && p?.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }
  function uuid() { return crypto.randomUUID(); }
  function scope(instance) {
    // Local-only dedup scope; never included in an external event payload.
    try { return String(instance?.sessionId || sessionStorage.getItem('taraConsultationSessionId') || 'page'); }
    catch (_) { return 'page'; }
  }
  function recorded(key) {
    try { return sent.has(key) || sessionStorage.getItem(prefix + key) === '1'; }
    catch (_) { return sent.has(key); }
  }
  function flush() {
    timer = null;
    if (!allowed()) { pending.clear(); return; }
    for (const [key, item] of pending) {
      if (++item.attempts > 10) { pending.delete(key); continue; }
      try {
        const publish = window.Shopify?.analytics?.publish;
        if (typeof publish !== 'function') continue;
        if (publish.call(window.Shopify.analytics, 'tara:meta_signal', item.payload) === false) continue;
        sent.add(key);
        try { sessionStorage.setItem(prefix + key, '1'); } catch (_) {}
        pending.delete(key);
      } catch (_) { /* never delay the consultation or cart */ }
    }
    if (pending.size) timer = setTimeout(flush, 1000);
  }
  function emit(name, localScope) {
    try {
      if (!names.has(name) || !allowed()) return false;
      const key = name + ':' + String(localScope || scope());
      if (recorded(key) || pending.has(key) || pending.size >= 20) return false;
      pending.set(key, { attempts: 0, payload: { event_name: name, event_id: uuid(), schema_version: '1', market: 'kw' } });
      if (!timer) flush();
      return true;
    } catch (_) { return false; }
  }
  function track(instance, name, data) {
    if (name === 'ConsultationProgress') {
      if (Number(data?.question_number) >= 3) emit('ConsultationEngaged', scope(instance));
      return;
    }
    if (name === 'ConsultationStarted' || name === 'ConsultationCompleted') emit(name, scope(instance));
  }
  function routineAdded(state, addedItems) {
    try {
      const expected = state?.routinePurchase?.addItems;
      if (state?.empty || state?.routinePurchase?.disabled || !expected?.length || !addedItems?.length) return;
      // Only the complete recommended routine, not an individual product click.
      const quantities = new Map();
      for (const item of addedItems) quantities.set(String(item.id), (quantities.get(String(item.id)) || 0) + Number(item.quantity));
      const required = new Map();
      for (const item of expected) required.set(String(item.id), (required.get(String(item.id)) || 0) + Number(item.quantity || 1));
      for (const [id, quantity] of required) if (!(quantity > 0) || !(quantities.get(id) >= quantity)) return;
      emit('ConsultationRoutineAdded', state.assessment?.assessment_id || scope());
    } catch (_) {}
  }
  document.addEventListener('visitorConsentCollected', function () {
    if (!allowed()) { pending.clear(); clearTimeout(timer); timer = null; }
  });
  window.TaraMetaSignals = Object.freeze({ emit, track, routineAdded });
})();
